import ApiGraphQL from './client'
import unwrapGraphQL from './unwrap'


// The whole row, not just the id: the caller builds the optimistic row from it.
const CREATE = `mutation ($input: RelationCreateInput!) {
    relationCreate(input: $input) {
        id
        type
        metadata
        sourceItemType
        sourceItemId
        targetItemType
        targetItemId
    }
}`

const DELETE = `mutation ($id: ID!) { relationDelete(id: $id) }`


type CreateInput = {
    sourceItemType    : number
    sourceItemId      : ID
    targetItemType    : number
    targetItemId      : ID
}


export default class ApiRelation {

    static create(input: CreateInput) {
        return unwrapGraphQL(ApiGraphQL.execute(CREATE, {input}), 'relationCreate')
    }

    static delete(id: ID) {
        return unwrapGraphQL(ApiGraphQL.execute(DELETE, {id}), 'relationDelete')
    }
}
